import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-admitance',
  templateUrl: './admitance.component.html',
  styleUrls: ['./admitance.component.scss']
})
export class AdmitanceComponent implements OnInit {
  @Input() subject;
  @Output() openDialog = new EventEmitter();

  constructor(private functions: AngularFireFunctions, private _snackBar: MatSnackBar, private dialog: MatDialog, private zone: NgZone) { }

  ngOnInit(): void {
  }
  
  openStudyboxClipsDialog(studybox) {
    this.openDialog.next(studybox);
  }

  openSnackBar(message, action) {
    this._snackBar.open(message, action)
  }

}
